//See EnvConfigurationService for dynamic configuration
export const environment = {
  production: true,
  apiUrl: 'https://wee.michelin.net',
  version: '1.0.0'
};
